import React, { forwardRef } from "react";
import { Box, Typography, Grid, Avatar, Table, TableBody, TableRow, TableCell, ListItem, List } from "@mui/material";
import "./newAdmitCard.css";

const data = {
  rollNumber: "RJ08708092",
  name: "SOHRAB ALI",
  dob: "19/10/2000",
  category: "OBC - NCL (CENTRAL LIST)",
  fatherName: "MD KASIM ANSARI",
  gender: "MALE",
  state: "BIHAR",
  applicationNumber: "190310286085",
  photoUrl: "/sohrab-photo.jpg",
  signatureUrl: "/sohrab-signature.png",
  paperMedium: "ENGLISH",
  course: "B.E./B.Tech. Only",
  reportingTime: "12.30PM (IST)",
  gateCloseTime: "02.00PM (IST)",
  examDate: "08.04.2019",
  shift: "Second",
  examTiming: "02.30PM TO 05.30PM (IST)",
  testCenterNo: "RJ0802",
  testVenue: "SATYA ONLINE EDUCATION OM KOTHARI INSTITUTE, KOTA, RAJASTHAN - 324005",
  instructions: [
    "Admit Card downloaded from the NTA website (a clear preferably colour printout on A4 size paper).",
    "One Passport size photograph...",
    "No Candidate would be allowed to enter...",
    "Candidates must write their name and Roll Number...",
    "Candidates are NOT allowed to use water colour on Drawing Sheet...",
    "Candidates should take their seat immediately...",
    "Candidates will NOT be permitted to leave before end...",
    "No Candidate should adopt any unfairness..."
  ]
};

const AdmitCard = forwardRef(({ cardData }, ref) => {
  console.log("carddata",cardData);
  return(
    <Box className="admit-cards" ref={ref}>
      {/* Header */}
      <Grid container justifyContent="space-between" className="mainheader">
        <Grid item>
          <img src="https://upload.wikimedia.org/wikipedia/commons/5/55/Emblem_of_India.svg" alt="Gov Logo" className="logo" />
        </Grid>
        <Grid item>
          <p className="header-subTitle">
            Joint Entrance Examination (MAIN)-2019 <br />

            <span>
              JEE(Main)-2025 <br />
              Admit Card - Provisional for April 2019</span>
          </p>
        </Grid>
        <Grid item>
          <img src="https://images.seeklogo.com/logo-png/55/1/indian-navy-logo-png_seeklogo-555192.png" alt="NTA Logo" className="logo" />
        </Grid>
      </Grid>

      {/* Candidate & Exam Details */}
      <Box className="details">
        <Grid container spacing={4}>
          <Grid item xs={6} >
            <Box className="student-details" mb={2}>
              <h4>Roll Number: </h4>
              <h5 style={{ fontWeight: 'bold' }}>{data.rollNumber}</h5>
            </Box>
            <Box className="student-details">
              <h4>Candidate's Name:</h4>
              <h5>{cardData?.candidate_details?.full_name}</h5>
            </Box>
            <Box className="student-details">
              <h4>Date of Birth:</h4>
              <h5>{cardData?.candidate_details?.dob}</h5>
            </Box>
            <Box className="student-details">
              <h4>Category:</h4>
              <h5>{cardData?.candidate_details?.category_type}</h5>
            </Box>

          </Grid>
          <Grid item xs={6}>
            <div className="bar-codeLines">
              <img src="https://pngimg.com/d/barcode_PNG10.png" alt="image" />
            </div>
            <Box className="student-details">
              <h4>Father's Name:</h4>
              <h5>{cardData?.candidate_details?.father_name}</h5>
            </Box>
            <Box className="student-details">
              <h4>Gender:</h4>
              <h5>{cardData?.candidate_details?.gender}</h5>
            </Box>

            <Box className="student-details">
              <h4>State of Eligibility:</h4>
              <h5>{data.state}</h5>
            </Box>

          </Grid>
        </Grid>

        <Box display={'flex'} justifyContent={'end'} alignItems={'center'}>
          <Typography fontWeight={600} fontSize={'14px'}>Application No:</Typography>
          <Typography fontWeight={550} fontSize={'14px'}>{data.applicationNumber}</Typography>
        </Box>
      </Box>

      {/* Test Details */}
      <Typography sx={{ textAlign: 'center', fontSize: '14px', fontWeight: 700 }}>Test Details</Typography>
      <Box className="test-details-box">
        <Grid container spacing={2}>
          {/* Left Side */}
          <Grid item xs={9}>
            <Box className="detail-table-header-row">
              <Box className="table-header-row-text">
                <h4>Paper Medium:</h4>
                <h5>{data.paperMedium}</h5>
              </Box>
              <Box className="table-header-row-text">
                <h4>Course Name:</h4>
                <h5>{data.course}</h5>
              </Box>
            </Box>
            <Table size="small" className="details-table">
              <TableBody>

                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Description:</TableCell>
                  <TableCell className="table-right-content bold">Paper-1</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Reporting Time at Centre:</TableCell>
                  <TableCell className="table-right-content">{data.reportingTime}</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Gate Closing Time of Centre:</TableCell>
                  <TableCell className="table-right-content">{data.gateCloseTime}</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Date of Examination:</TableCell>
                  <TableCell className="table-right-content bold">{data.examDate}</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Shift:</TableCell>
                  <TableCell className="table-right-content bold">{data.shift}</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Timing of Test:</TableCell>
                  <TableCell className="table-right-content">{data.examTiming}</TableCell>
                </TableRow>
                <TableRow className="detail-table-row">
                  <TableCell className="table-left-content">Test Centre No:</TableCell>
                  <TableCell className="table-right-content">{data.testCenterNo}</TableCell>
                </TableRow>
                <TableRow sx={{ height: '100px' }}>
                  <TableCell className="table-left-content">Venue of Test:</TableCell>
                  <TableCell  className="table-right-content">
                    SATYA ONLINE EDUCATION OM KOTHARI INSTITUTE A-1 SPECIAL, IPNA JHALAWAR ROAD,
                    ANANTPURA, KOTA, RAJASTHAN - 324005
                  </TableCell>
                </TableRow>

              </TableBody>
            </Table>
          </Grid>

          {/* Right Side */}
          <Grid item xs={3} className="right-section" style={{ padding: 0 }}>
            <div className="photo-box">
              <p className="photo-label">Photograph</p>
              <img src="https://t4.ftcdn.net/jpg/10/17/46/67/360_F_1017466748_sPimgAiwEJECag85DWHsrufuLsugsh6b.jpg" alt="Candidate" className="photo" />
              {/* <Typography className="photo-name">SOHRAB ALI<br />08-09-2018</Typography> */}
            </div>

            <div className="signature-box">
              <img src="https://onlinepngtools.com/images/examples-onlinepngtools/marilyn-monroe-signature.jpg" alt="Signature" className="signature" />
              <Typography variant="body2" className="nta-sign">Candidate Signature</Typography>
            </div>
            <div className="signature-box2">
              <img src="https://onlinepngtools.com/images/examples-onlinepngtools/marilyn-monroe-signature.jpg" alt="Signature" className="signature" />
              <Typography variant="body2" className="nta-sign">
                NTA-JEE(Main) Unit
              </Typography>
            </div>


          </Grid>
        </Grid>

      </Box>

      {/* Instructions */}
      {/* <Box className="instructions">
        <p className="instruction-title">
          IMPORTANT INSTRUCTIONS FOR CANDIDATES
        </p>
        <ul>
          {data.instructions.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </Box> */}
       <div className="instructions">
      <p className="instruction-title">
          IMPORTANT INSTRUCTIONS FOR CANDIDATES
        </p>
      <List className="instructions-list">
        <ListItem>
          <span className="number"></span> The Admit Card is provisional, subject to the eligibility conditions given in the Information Bulletin.
        </ListItem>
        <ListItem>
          <span className="number"></span> Candidates are suggested to visit the examination venue, a day in advance, so that they can reach the venue on time on the day of examination.
        </ListItem>
        <ListItem>
          <span className="number"></span> <span className="blue">Candidates are required to present the following documents to the examination officials, for identity verification:</span><br />
          <span className="red">• Admit Card downloaded from the NTA website (a clear preferably colour printout on A4 size paper).</span><br />
          <span className="red">• One Passport size photograph</span> 
          <span className="blue"> (same as uploaded with the Online Application Form)</span> to be pasted on the attendance sheet at the Centre.<br />
          <span className="red">• One original and valid Photo Identification Proof  <span className="blue">issued by the government</span>  – PAN card/Driving License/Voter ID/Passport/ Aadhaar Card (With photograph)/e-Aadhaar/ Ration Card/Aadhaar Enrolment No. with Photo.</span><br />
          <span className="red">• PwD certificate issued by the Competent Authority, if claiming the relaxation under PwD category.</span><br/>
          <span className="red">• Note: No Candidate would be allowed to enter the Examination Centre, without identity verification.</span>
        </ListItem>
        <ListItem>
          <span className="number"></span> Candidates are NOT allowed to carry any personal belongings including electronic devices, mobile phone and other materials listed in the Information Bulletin, to the Examination Centre. Examination Officials will not be responsible for safe keeping of personal belongings.
    <br/>
          <span className="bold"> Pen/ Pencil and blank paper sheets for rough work will be provided in the examination Hall/Room. <span >Candidates must write their name and Roll Number at the top of the sheet, and must return the sheet to the Invigilator, before leaving the examination Hall/Room.</span><br />
      </span>
        </ListItem>
        <ListItem>
          <span className="number"></span> Candidates should take their seat immediately after opening of the Examination Hall. They can login and read instructions, before the commencement of the examination.
        </ListItem>
        <ListItem>
          <span className="number"></span> Candidates will <span className="red">NOT be permitted to leave the Examination Room/Hall before the end of examination.</span> After the completion of the examination, candidates should hand over their Admit Card, rough sheet and Pen/Pencil to the invigilator on duty.
        </ListItem>
        <ListItem>
          <span className="number"></span> Candidates must enter required details in the Attendance Sheet in legible handwriting, put their signature and paste the Photograph at the appropriate place. They should ensure that their Left-Hand Thumb Impression is clear and not smudged.
        </ListItem>
        <ListItem>
          <span className="number"></span> <span className="red">No Candidate should adopt any unfairmeans, or indulge in any unfair examination practices. The candidature of Candidates appearing more than once in JEE (Main) April 2019 examination will be automatically cancelled without any notice.</span>
        </ListItem>
      </List>
      <Typography className="note">
        Candidates are advised to check updates on NTAs website regularly. They may also check their mail box on the registered E-mail address and SMS in their registered Mobile No. for latest updates and information.
      </Typography>
      <Typography variant="body2" className="nta-contact">
        NTA website: <a href="https://www.nta.ac.in" target="_blank" rel="noopener noreferrer">www.nta.ac.in</a> and <a href="https://jeemain.nta.nic.in" target="_blank" rel="noopener noreferrer">jeemain.nta.nic.in</a><br />
        For any Assistance : Email: <a href="mailto:jeemain-nta@gov.in">jeemain-nta@gov.in</a> | SMS: 7042399521, 7042399525-526
      </Typography>
    </div>
             <Typography className="note" pt={1}>Note: No Candidate would be allowed to enter the Examination Centre, after gate closing time mentioned on the Admit Card</Typography>

    </Box>
  );
})

export default AdmitCard;
